<template>
  <div id="app">
    <!-- <Top/> -->
    <router-view v-if="newCategoryList.length>0" :siteList="siteList" :categoryList="newCategoryList" />
    <!-- <div class="float_side">
      <div class="float_top">
        <img src="@/assets/img/onlinemessage.png" alt="">
        <div>在线留言</div>
      </div>
      <div class="float_bottom">
        <div class="float_item" @mouseover="isShow2(true)" @mouseleave="isShow2(false)">
          <svg t="1733985619175" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="10521" width="30" height="30">
            <path
              d="M832 762.24 832 768c0 96.64-83.84 176-192 189.44L640 928c0-17.92-14.08-32-32-32l-128 0C462.08 896 448 910.08 448 928l0 64C448 1009.92 462.08 1024 480 1024l128 0c159.36 0 288-114.56 288-256l0-5.76M896 762.24c37.12-13.44 64-48.64 64-90.24l0-128c0-41.6-26.88-76.8-64-90.24L896 448c0-211.84-172.16-384-384-384C300.16 64 128 236.16 128 448l0 5.76C90.88 467.2 64 502.4 64 544l0 128C64 725.12 106.88 768 160 768S256 725.12 256 672l0-128c0-41.6-26.88-76.8-64-90.24L192 448c0-176.64 143.36-320 320-320 176.64 0 320 143.36 320 320l0 5.76c-37.12 13.44-64 48.64-64 90.24l0 128c0 41.6 26.88 76.8 64 90.24M192 672C192 689.92 177.92 704 160 704S128 689.92 128 672l0-128C128 526.08 142.08 512 160 512S192 526.08 192 544L192 672zM896 672c0 17.92-14.08 32-32 32S832 689.92 832 672l0-128C832 526.08 846.08 512 864 512S896 526.08 896 544L896 672z"
              p-id="10522"></path>
          </svg>
          <span>电话咨询</span>
          <div class="float_c" :style="{'display':showItem2?'flex':'none'}">
            <span>咨询热线</span>
            <span>{{siteList.contact_phone}}</span>
          </div>
        </div>
        <div class="float_item" @mouseover="isShow(true)" @mouseleave="isShow(false)">
          <svg t="1733985685252" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="12205" id="mx_n_1733985685253" width="30" height="30">
            <path
              d="M737.673809 863.903745 737.673809 800.13335 672.503531 800.13335 672.503531 863.949794ZM834.943157 863.949794c15.954367 0 29.006637-13.053294 29.006637-29.006637l0-34.808784-62.461587 0 0 63.769372M415.311891 223.865627l0 191.447287L223.864604 415.312914 223.864604 223.865627 415.311891 223.865627M450.120674 160.050206 189.05582 160.050206c-15.953344 0-29.006637 13.053294-29.006637 29.006637l0 261.063831c0 15.954367 13.053294 29.006637 29.006637 29.006637l261.063831 0c15.953344 0 29.006637-13.053294 29.006637-29.006637L479.126288 189.056843C479.127312 173.1035 466.074018 160.050206 450.120674 160.050206L450.120674 160.050206zM319.588759 319.589782m-31.907711 0a31.181 31.181 0 1 0 63.815421 0 31.181 31.181 0 1 0-63.815421 0ZM800.134373 223.865627l0 191.447287L608.688109 415.312914 608.688109 223.865627 800.134373 223.865627M834.943157 160.050206 573.879326 160.050206c-15.954367 0-29.006637 13.053294-29.006637 29.006637l0 261.063831c0 15.954367 13.053294 29.006637 29.006637 29.006637l261.063831 0c15.954367 0 29.006637-13.053294 29.006637-29.006637L863.949794 189.056843C863.950817 173.1035 850.897523 160.050206 834.943157 160.050206L834.943157 160.050206zM704.411241 319.589782m-31.907711 0a31.181 31.181 0 1 0 63.815421 0 31.181 31.181 0 1 0-63.815421 0ZM415.311891 608.687086l0 191.447287L223.864604 800.134373 223.864604 608.687086 415.311891 608.687086M450.120674 544.871665 189.05582 544.871665c-15.953344 0-29.006637 13.053294-29.006637 29.006637l0 261.063831c0 15.954367 13.053294 29.006637 29.006637 29.006637l261.063831 0c15.954367 0 29.006637-13.053294 29.006637-29.006637L479.126288 573.878303C479.127312 557.924959 466.074018 544.871665 450.120674 544.871665L450.120674 544.871665zM319.588759 704.410218m-31.907711 0a31.181 31.181 0 1 0 63.815421 0 31.181 31.181 0 1 0-63.815421 0ZM834.943157 544.871665l-35.579333 0 0 127.630842-63.815421 0L735.548402 544.871665 573.879326 544.871665c-15.954367 0-29.006637 13.053294-29.006637 29.006637l0 261.063831c0 15.954367 13.053294 29.006637 29.006637 29.006637l34.808784 0 0-63.815421 0-63.815421 0-63.815421 63.815421 0 0 63.815421L863.950817 736.317928l0-162.439626C863.950817 557.924959 850.897523 544.871665 834.943157 544.871665z"
              p-id="12206"></path>
          </svg>
          <span>扫码体验</span>
          <div class="float_code" :style="{'display':showItem?'block':'none'}">
            <img :src="siteList.wechat_public" alt="">
          </div>
        </div>
      </div>
    </div> -->
     <!-- 侧边栏 -->
     <div id="sidebar">
      <div @mouseover="showChengxu=true" @mouseleave="showChengxu=false" class="hover-revert re1">
        <div class="si"><i class="si1"></i></div>
        <div class="text">小程序</div>
        <div v-show="showChengxu" class="tooltip">
          <div class="tooltip_content">
            <img :src="siteList.wechat_program">
            <div>机智鸟小程序</div>
            <div class="tooltip_arrow"></div>
          </div>
        </div>
      </div>
      <div @mouseover="showPublic=true" @mouseleave="showPublic=false" class="hover-revert re2">
        <div class="si"><i class="si2"></i></div>
        <div class="text">公众号</div>
        <div v-show="showPublic" class="tooltip">
          <div class="tooltip_content">
            <img :src="siteList.wechat_public">
            <div>机智鸟公众号</div>
            <div class="tooltip_arrow"></div>
          </div>
        </div>
      </div>
      <div class="hover-revert re3">
        <a href="https://www.jzn.com/vip.html">
          <div class="si"><i class="si3"></i></div>
          <div class="text">会员</div>
        </a>
      </div>
      <div @mouseover="showKefu=true" @mouseleave="showKefu=false" class="hover-revert re4">
        <div class="si"><i class="si4"></i></div>
        <div class="text">微信</div>
        <div v-show="showKefu" class="tooltip">
          <div class="tooltip_content">
            <img :src="siteList.wechat_kefu">
            <div>微信扫码添加专属客服</div>
            <div class="tooltip_arrow"></div>
          </div>
        </div>
      </div>
      <div class="hover-revert sfeedback re5">
        <div class="si"><i class="si5"></i></div>
        <div class="text">反馈</div>
      </div>
      <div @mouseover="xnKefu=true" @mouseleave="xnKefu=false" class="hover-revert re6">
        <div class="si"><i class="si6"></i></div>
        <div class="text">立即咨询</div>
        <div v-show="xnKefu" class="tooltip">
          <div class="tooltip_content">
            <img :src="siteList.wechat_kefu">
            <div>机智鸟客服</div>
            <div class="tooltip_arrow"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  // import Top from '@/components/top'
  export default {
    components: {
      // Top,
    },
    data() {
      return {
        showChengxu:false,
        showPublic:false,
        showKefu:false,
        xnKefu:false,
        siteList: {},
        categoryList: [],
        showItem:false,
        showItem2:false
      }
    },
    computed: {
      newCategoryList() {
        return this.categoryList
      }
    },
    created() {
      this.getSite()
      this.getCategory()
    },
    metaInfo() {
      return {
        meta: [
          {
            name: 'keywords',
            content: this.siteList ? this.siteList.seo_keywords : ' ',
          },
          {
            name: 'description',
            content: this.siteList ? this.siteList.seo_description : ' ',
          },
        ],
      }
    },
    watch: {
      siteList: {
        handler(newVal) {
          if (newVal.length > 0) {
            this.$nextTick(() => {
              this.updateMetaInfo();
            });
          }
        },
        immediate: true,
      },
    },
    methods: {
      updateMetaInfo() {
        this.$metaInfo.meta = [
          {
            name: 'keywords',
            content: this.siteList.seo_keywords,
          },
          {
            name: 'description',
            content: this.siteList.seo_description,
          },
        ];
      },
      isShow(item){
        this.showItem=item
      },
      isShow2(item){
        this.showItem2=item
      },
      async getSite() {
        const res = await this.$request.post('seo/getSite')
        if (res.data.code === 0) {
          this.siteList = res.data.data[0]
        }
      },
      async getCategory() {
        let res = await this.$request.post('category/getAll', {
          fil: 1
        })
        if (res.data.code === 0) {
          this.categoryList = res.data.data
          this.categoryList = this.categoryList.reduce((acc, item) => {
            // 检查是否已经存在具有相同title的类别
            const existingCategory = acc.find(category => category.title === item.title);

            if (existingCategory) {
              // 如果存在，则将当前项添加到该类别的subItem数组中
              existingCategory.subItem.push({
                sec_path: item.sec_path,
                sec_title: item.sec_title,
                category_id: item.category_id,
                sec_banner: item.sec_banner
              });
            } else {
              // 如果不存在，则创建一个新类别，并将当前项添加到该类别的subItem数组中
              acc.push({
                id: item.id,
                title: item.title,
                path: item.path,
                status: item.status,
                banner: item.pic,
                subItem: [
                  {
                    sec_path: item.sec_path,
                    sec_title: item.sec_title,
                    category_id: item.category_id,
                    sec_banner: item.sec_banner
                  }
                ]
              });
            }

            return acc;
          }, []);
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
#sidebar {
    position: fixed;
    z-index: 9999;
    text-align: center;
    right: 10px;
    top: 50%;
    margin-top: -220px;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
  }

  #sidebar .hover-revert {
    color: #7a808f;
    padding: 5px;
    background-color: #fff;
    cursor: pointer;
    position: relative;
  }

  #sidebar .tooltip {
    position: absolute;
    left: -190px;
    top: -50px;
    background-color: #fff;
    font-size: 12px;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    /* display: none; */
  }

  #sidebar .hover-revert:first-child {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  #sidebar .hover-revert .si {
    padding: 10px 10px 5px 10px;
    text-align: center;
  }

  #sidebar .hover-revert .si i{
    width: 24px;
    height: 24px;
    display: inline-block;
    background-image: url('../src/assets/img/si.png');
    background-repeat: no-repeat;
  }

  #sidebar .hover-revert .si1{
    background-position: 0 0;
  }
  #sidebar .re1:hover{
    background-color: #055fe6;
  }
  #sidebar .re1:hover .text{
    color: #FFFFFF;
  }
  #sidebar .re1:hover .si1{
    background-position: -24px 0;
  }
  #sidebar .hover-revert .si2 {
    background-position: 0 -24px;
  }
  #sidebar .re2:hover{
    background-color: #055fe6;
  }
  #sidebar .re2:hover .text {
    color: #FFFFFF;
  }
  #sidebar .re2:hover .si2 {
    background-position: -24px -24px;
  }
  #sidebar .hover-revert .si3 {
    background-position: 0 -48px;
  }
  #sidebar .re3:hover{
    background-color: #055fe6;
  }
  #sidebar .re3:hover .text {
    color: #FFFFFF;
  }
  #sidebar .re3:hover .si3 {
    background-position: -24px -48px;
  }
  #sidebar .re3>a{
    color: #7a808f;
    text-decoration: none;
  }
  #sidebar .hover-revert .si4 {
    background-position: 0 -72px;
  }
  #sidebar .re4:hover{
    background-color: #055fe6;
  }
  #sidebar .re4:hover .text {
    color: #FFFFFF;
  }
  #sidebar .re4:hover .si4{
    background-position: -24px -72px;
  }
  #sidebar .hover-revert .si5 {
    background-position: 0 -96px;
  }
  #sidebar .re5:hover{
    background-color: #055fe6;
  }
  #sidebar .re5:hover .text {
    color: #FFFFFF;
  }
  #sidebar .re5:hover .si5 {
    background-position: -24px -96px;
  }
  #sidebar .hover-revert .si6 {
    background-position: 0 -120px;
 }
 #sidebar .re6:hover{
    background-color: #055fe6;
  }
  #sidebar .re6:hover .text {
    color: #FFFFFF;
  }
 #sidebar .re6:hover .si6 {
    background-position: -24px -120px;
 }

  #sidebar .hover-revert .text {
    font-size: 12px;
  }

  #sidebar .tooltip .tooltip_content{
    padding: 12px 16px;
    color: #333;
    text-align: center;
  }
  #sidebar .tooltip .tooltip_content img{
    width: 140px;
    height: 140px;
    margin-bottom: 10px;
  }
  #sidebar .tooltip .tooltip_arrow{
    position: absolute;
    display: block;
    width: 8.48528137px;
    height: 8.48528137px;
    background: transparent;
    border-style: solid;
    border-width: 4.24264069px;
    top: 50%;
    -webkit-transform: translateY(-50%) rotate(45deg);
    transform: translateY(-50%) rotate(45deg);
    right: -1px;
    border-color: #fff #fff transparent transparent;
    -webkit-box-shadow: 3px -3px 7px rgba(0, 0, 0, .07);
    box-shadow: 3px -3px 7px rgba(0, 0, 0, .07);
  }
  #sidebar .hover-revert:last-child {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
 }
</style>